/**
 * The interceptor checks if the requests are internal and then adds additional headers for debugging purposes in azure
 * NOTE THAT IF YOU CHANGE ANY 3RD PARTY REQUESTS THEY MIGHT BOUNCE EG GOOGLE MAPS API
 */
import { Inject, Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@boma/app-config';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private base: string;

  constructor(@Inject(APP_CONFIG) private configuration: any) {
    this.base = configuration.apiRoute;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const bomaApi = request.url.indexOf(this.base) > -1;
    if (!bomaApi) return next.handle(request); // IMPORTANT if you modify 3rd party headers you will not get results back from their api's
    const date = new Date();
    const clonedRequest = request.clone({
      setHeaders: {
        'X-Timezone-Offset': (-date.getTimezoneOffset()).toString(),
        'X-Platform': 'Supplier Portal', // figure out what we should be passing
        'X-User-Platform': 'Browser'
        // ADD ANY ADDITIONAL DATA YOU WANT TO TRACK IN AZURE
      },
    });

    return next.handle(clonedRequest);
  }
}
